import { render, staticRenderFns } from "./VideoMiniControl.vue?vue&type=template&id=1661a9d4&scoped=true&"
import script from "./VideoMiniControl.vue?vue&type=script&lang=js&"
export * from "./VideoMiniControl.vue?vue&type=script&lang=js&"
import style0 from "./VideoMiniControl.vue?vue&type=style&index=0&id=1661a9d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1661a9d4",
  null
  
)

export default component.exports